import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-9",
  "use": "icon-icon-nav-9-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-9\"><path d=\"M713.6 680h-403.2v-67.2h403.2v67.2z m0-134.4h-403.2v-67.2h403.2v67.2z m0-134.4h-403.2v-67.2h403.2v67.2zM209.6 848l50.432-50.368 50.368 50.368 50.432-50.368 50.368 50.368 50.432-50.368 50.368 50.368 50.368-50.368 50.432 50.368 50.432-50.368 50.368 50.368 50.368-50.368 50.432 50.368V176l-50.368 50.432-50.432-50.432-50.368 50.432-50.432-50.432-50.368 50.432L512 176l-50.368 50.432-50.432-50.432-50.368 50.432-50.432-50.432-50.368 50.432-50.432-50.432v672z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-9.svg
// module id = B06n
// module chunks = 3